export default {
  monday: 'Pirmadienis',
  tuesday: 'Antradienis',
  wednesday: 'Trečiadienis',
  thursday: 'Ketvirtadienis',
  friday: 'Penktadienis',
  lunchEditing: 'Patiekalų Redagavimas',
  monthlyExpenses: 'Vartotojų Išlaidos',
  ordersHistory: 'Užsakymų Istorija',
  ordersList: 'Užsakymų Sąrašas',
  ordersCounts: 'Užsakymų Kiekiai',
  dishesRatings: 'Patiekalų Įvertinimai',
  settings: 'Nustatymai',
  signOut: 'Atsijungti',
  noSelections: 'Nieko nepasirinkta',
  lunchArrivedNotification: 'Siųsti pranešimą, jog pietūs atkeliavo',
  dishRatingsNotification: 'Siųsti pranešimą, primenantį įvertinti patiekalus',
  notifications: 'Pranešimai',
  selectNotifications: 'Pasirinkite kuriuos pranešimus gauti',
  lunchArrived: 'Pietūs atkeliavo į ofisą',
  '10minutesReminder': '10 Minučių priminimas.',
  fridayLunchAdded: 'Pietūs buvo pridėti',
  orderRatingReminder: 'Užsakymo įvertinimo priminimas',
  notifiedUsers: 'Pranešimas sėkmingai išsiųstas.',
  notificationsError: 'Siunčiant pranešimą įvyko nenumatyta klaida.',
  rateLunch: 'Atsiliepimas apie pietus',
  rateLunchOn: 'Atsiliepimas apie {date} pietus {providerTitle}',
  rateLunchSubtitle: 'Pasirinkite atitinkamą įvertinimą ir pagal poreikį palikite komentarą.',
  soup: 'Sriuba {dish}',
  main: 'Pagr. patiekalas {dish}',
  comment: 'Komentaras',
  modalHeader: 'Pasirinkite tinkamas parinktis',
  modalSubHeader: 'Tai bet kuriuo metu bus galima keisti nustatymuose.',
  displayName: 'Vardas ir Pavardė',
  notEnabled: 'Pranešimų gavimas yra išjungtas',
  pleaseEnable: 'Pasirinkta negauti pranešimų (Push Notifications) arba ši naršyklė to nepalaiko.',
  saveButton: 'Išsaugoti pasirinkimus',
  commentMustNotExceed: 'Komentaras negali būti ilgesnis, nei {count} simbolių.',
  orderSaved: 'Užsakymas išsaugotas.',
  doNotOrder: 'Praleisti pietus šiai dienai.',
  manageNotifications: 'Valdyti siunčiamus pranešimus.',
  usersBalances: 'Vartotojų Balansai',
  balanceInfo: `Užsakymai galimi tik turint pakankamą pinigų likutį
  (išskyrus Penktadienio nemokamus pietus). Norėdami papildyti pinigų likutį, kreipkitės į ofiso administratorę(-ių).`,
  balanceReminder: 'Žemo balanso priminimas',
  balanceReminderNotification: 'Siųsti balanso papildymo pranešimą naudotojams, turintiems žemą balansą',
  balanceTresholdField: 'Balanso riba',
  orderAmount: 'Užsakymo suma',
  selectedDishes: 'Pasirinkti Patiekalai',
};
